"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightCommentEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Textarea_1 = require("../../../Form/Field/Textarea");
const FlightCommentEditor = (props) => {
    const { field } = props;
    const fieldProps = {
        name: 'comment',
        modificators: field.modifiers,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Note', defaultMessage: 'Note' })),
        error: field.error,
        value: field.value,
        onChange: field.onEvent,
    };
    return (react_1.default.createElement(Textarea_1.FormFieldTextarea, { ...fieldProps }));
};
exports.FlightCommentEditor = FlightCommentEditor;
//# sourceMappingURL=FlightCommentEditor.js.map